import { ReactNode, useEffect, useRef, useState } from "react";

type MinimalExpandableTextProps = {
  children: ReactNode;
  className?: string;
};

export const MinimalExpandableText = ({
  children,
  className = "",
}: MinimalExpandableTextProps): JSX.Element => {
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    setShowToggle(element.scrollHeight > element.clientHeight);
  }, [children]);

  const lineClampClass = !expanded ? "line-clamp-5" : "";

  return (
    <div className='w-full'>
      <div ref={ref} className={`${lineClampClass} break-words ${className}`}>
        {children}
      </div>

      <div>
        {showToggle && (
          <button
            onClick={() => setExpanded((prev) => !prev)}
            className='text-xs text-primary underline mt-1'
          >
            {expanded ? "Show Less" : "Show More"}
          </button>
        )}
      </div>
    </div>
  );
};
